module.exports = __webpack_public_path__ + "static/img/6608_phase_function_Paper_Points.b8d0115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6608_phase_function_Paper_Points.png
// module id = p3X7
// module chunks = 0